import { memo, useCallback } from 'react';

import { Checkbox } from '@air/primitive-checkbox';

export type SignUpAutoVerifyCheckboxProps = {
  id: string;
  checked: boolean;
  disabled: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export const SignUpAutoVerifyCheckbox = memo(
  ({ id, checked, disabled, onCheckedChange }: SignUpAutoVerifyCheckboxProps) => {
    const handleCheckedChange = useCallback(
      (nextChecked: boolean | 'indeterminate') => {
        onCheckedChange(nextChecked === true);
      },
      [onCheckedChange],
    );

    return (
      <label className="mt-3 flex items-center gap-2 ads:text-secondary text-10 text-gray-11" htmlFor={id}>
        <Checkbox
          checked={checked}
          data-testid="SIGN_UP_AUTO_VERIFY_CHECKBOX"
          disabled={disabled}
          id={id}
          onCheckedChange={handleCheckedChange}
          size="small"
        />
        <span>
          Auto-verify email <span className="ads:text-metadata text-gray-9">(dev stage only)</span>
        </span>
      </label>
    );
  },
);

SignUpAutoVerifyCheckbox.displayName = 'SignUpAutoVerifyCheckbox';
